import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, ApiResourceLocation, Dictionary } from '@softline/core';
import { GarageTask } from '../models/garage-task';
import { SOFTLINE_API_GARAGE_ORDER_TASKS, SOFTLINE_API_GARAGE_TASK, SOFTLINE_API_GARAGE_TASKS } from '../garage.api';

@Injectable()
export class TaskRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  private createLocation(
    path: string,
    pathParams?: Dictionary<unknown> | null,
    queryParams?: Dictionary<unknown> | null
  ): ApiResourceLocation {
    const location: ApiResourceLocation = { path };
    if (pathParams) {
      location.pathParams = pathParams;
    }
    if (queryParams) {
      location.queryParams = queryParams;
    }
    return location;
  }

  retrieveUnproductiveTasks(): Promise<GarageTask[]> {
    return this.#dataAccess.get(
      this.createLocation(SOFTLINE_API_GARAGE_TASKS, null, { type: 'unproductive' })
    );
  }

  retrieveById(id: number): Promise<GarageTask> {
    return this.#dataAccess.get(this.createLocation(SOFTLINE_API_GARAGE_TASK, { id }));
  }

  //garage/tasks?type=order“&orderId=1234
  retrieveForOrderByTypeAndId(orderId: number): Promise<GarageTask[]> {
    return this.#dataAccess.get(
      this.createLocation(SOFTLINE_API_GARAGE_ORDER_TASKS, null, {
        type: 'order',
        orderId,
      })
    );
  }
}
